import React from 'react';
import GridFilterItem from '../../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../../../Base/Components/GridFilter/GridFilter';

interface FilterItem {
	value: string;
	label: string;
}

export interface CareClaimsFilter {
	doctor?: FilterItem;
	patient?: FilterItem;
}

interface Props {
	setFilter: (filter: CareClaimsFilter) => void;
}

const ManagerInsuranceCompaniesCareClaimFilter = React.memo(
	({ setFilter }: Props) => {
		return (
			<GridFilter onChange={setFilter}>
				<GridFilterItem
					type={GridFilterItemType.PATIENT_ORIGINAL_ID}
					width={340}
					enableAutocomplete
					customLabel='component.reportedCare.filterPatient'
				/>
				<GridFilterItem
					type={GridFilterItemType.DOCTOR_ID_PREFETCH}
					width={320}
					enableAutocomplete
					customLabel='component.reportedCare.filterDoctor'
				/>
			</GridFilter>
		);
	},
);

export default ManagerInsuranceCompaniesCareClaimFilter;
